import React, { useState } from 'react';
import ECargoLogoAndBlurbView from '../../Common/Components/ECargoLogoAndBlurbView.jsx';
import PopupView from '../../../Common/Components/PopupView.jsx';
import NotificationActions from '../../../Common/Actions/NotificationActions';
import QueryString from 'query-string';
import ResetPasswordActions from '../Actions/ResetPasswordActions.js';
import ShowSpinnerOnActionInProgress from '../../../Common/Components/ShowSpinnerOnActionInProgress.jsx';
import { Link, useLocation, useNavigate } from 'react-router-dom-v5-compat';
import Configuration from "../../../Common/Globals/Scripts/Configuration.js";
import { passwordRequirementHintTexts } from "../../../Common/Globals/Scripts/PasswordRequirementHintTexts.js";

export default function ResetPasswordPageView() {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const location = useLocation();
    const navigate = useNavigate();

    function retrieveResetPasswordParameters() {
        if(location.search) {
            const parameters = QueryString.parse(location.search);

            var userNameParameter = '';
            var codeParameter = '';

            if(parameters.userName) {
                userNameParameter = parameters.userName;
            }
            if(parameters.code) {
                codeParameter = parameters.code;
            }

            return {
                userName: userNameParameter,
                resetCode: codeParameter
            };
        }
    }

    function handlePasswordChange(event) {
        setPassword(event.target.value);
    }

    function handleConfirmPasswordChange(event) {
        setConfirmPassword(event.target.value);
    }

    const handleResetPassword = async (event) => {
        NotificationActions.clearNotifications();
        event.preventDefault();
        if(!password || !confirmPassword || password.trim() === '' || password !== confirmPassword) {
            NotificationActions.notificationReceived({
                icon: 'warning',
                severity: 'failure',
                title: 'Passwords must not be empty and must match',
                messages: ['Please check that you have entered the correct password in both the new password and confirm new password boxes.']
            });
        } else {
            var parameters = retrieveResetPasswordParameters();
            const wasResetSuccessful = await ResetPasswordActions.resetPassword(password, parameters.userName, parameters.resetCode);

            if(wasResetSuccessful) {
                setTimeout(() => {
                    const destinationUrl = `${Configuration.basePath}/Auths/LogIn`;
                    navigate(destinationUrl);
                }, 5000);
            }
        }
    };

    function createPopupElementForPasswordRequirements(element) {
        return (
            <PopupView
                element={ element }
                heading={ "Password requirements" }
                contents={ passwordRequirementHintTexts } />
        );
    }

    const passwordField = (
        <input id="password" type="password" value={ password } onChange={ handlePasswordChange } />
    );
    const passwordFieldWithRequirements = createPopupElementForPasswordRequirements(passwordField);

    return (
        <ECargoLogoAndBlurbView>
            <ShowSpinnerOnActionInProgress>{
                <div className="reset">
                    <form>
                        <div className="details">
                            <label>New password</label>
                            { passwordFieldWithRequirements }

                            <label>Confirm new password</label>
                            <input id="confirmPassword" type="password" value={ confirmPassword } onChange={ handleConfirmPasswordChange } />
                        </div>
                        <div className="links">
                            <button
                                id="reset"
                                type="submit"
                                className="primary button"
                                onClick={ handleResetPassword } >
                                Reset password
                            </button>
                            <Link id="logInPageLink" to="/App/Auths/LogIn">Return to login</Link>
                        </div>
                    </form>
                </div>
            }</ShowSpinnerOnActionInProgress>
        </ECargoLogoAndBlurbView>
    );
}
